import { formatPrice } from "../../utils/formatPrice";
import GuideSection from "../../components/guide/GuideSection";
import { domiciliationGuide } from "../../components/guide/guideContent";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Image,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import pricing from "../../assets/data/pricing.json";
import { FaMoneyBill } from "react-icons/fa";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import {
  cardPayment,
  checkPayment,
  mobilePayment,
  setPaymentFrom,
} from "../../redux/actions/PaymentActions";
import Loader from "../loader/Loader";
import CardPaymentTile, { CardPaymentNote } from "../payment/CardPaymentTile";
import { CARD } from "../payment/CardPaymentMethod";
import useCardMethod from "../../hooks/useCardMethod";
import serviceCode from "../../assets/data/serviceCode.json";
import { handleSubscribe } from "../../redux/actions/SubscriptionActions";
import { useNavigate } from "react-router-dom";
import { openCardCheckout } from "../../utils/cardCheckout";

function DomiciliationSubscription({ from }) {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const { user } = useSelector((state) => state.authUser);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const cardMethod = useCardMethod();
  const { activeCompany } = useSelector((state) => state.companies);

  const handleSubscribeClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const phoneSchema = Yup.object({
    phoneNumber: Yup.string().required("Le numéro de téléphone est requis"),
  });

  const formik = useFormik({
    initialValues:
      selectedPayment === "OM" || selectedPayment === "MOMO"
        ? { phoneNumber: "" }
        : {},
    validationSchema:
      selectedPayment === "OM" || selectedPayment === "MOMO"
        ? phoneSchema
        : null,
    onSubmit: async (values) => {
      setSubmitting(true);
      await dispatch(
        handleSubscribe(
          user.token,
          {
            company: activeCompany._id,
            services: [
              {
                code: serviceCode.domiciliation,
                billing: selectedPlan === "annuel" ? "yearly" : "monthly",
              },
            ],
          },
          (response) => handleCallback(response, values),
        ),
      );
    },
  });

  const handleCallback = async ({ success, data, message }, values) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      if (selectedPayment === "OM" || selectedPayment === "MOMO") {
        await dispatch(
          mobilePayment(
            user.token,
            {
              request: data.reference,
              phone: values.phoneNumber,
            },
            handleMobilePaymentCallback,
          ),
        );
      } else if (selectedPayment === CARD) {
        await dispatch(setPaymentFrom("dashboard"));
        await dispatch(
          cardPayment(
            user.token,
            {
              request: data.reference,
            },
            handleCardPaymentCallback,
          ),
        );
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handleMobilePaymentCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        checkPayment(
          user.token,
          data.reference,
          "request",
          handleCheckPaymentCallback,
        ),
      );
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handleCheckPaymentCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      }).then(() => {
        if (from === "newSubscription") {
          navigate(-1, { replace: true });
        } else {
          window.location.reload();
        }
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleCardPaymentCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      setSubmitting(false);
      openCardCheckout(navigate, data);
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handlePaymentSelect = (method) => {
    setSelectedPayment(method);
    formik.resetForm();
  };

  return (
    <Container fluid style={{ padding: 0 }}>
      <Loader isLoading={submitting} />
      {/* Section Image Bannière */}
      <>
        {/* Section Services */}
        <Container className="text-center py-1">
          <h4 className="mb-4" style={{ fontWeight: "400" }}>
            Les avantages de l'offre de domiciliation
          </h4>
          <Row>
            <Col md={4} className="mb-3">
              <Image
                src="/images/domiciliation/administrative_and_tax_address.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />

              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Adresse administrative & fiscale
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <Image
                src="/images/domiciliation/mail_reception_and_sorting.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />

              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Réception et tri de courrier
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <Image
                src="/images/domiciliation/mail_scanning.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Scan de courrier sécurisé
              </div>
            </Col>
            <Col md={6} className="mb-3">
              <Image
                src="/images/domiciliation/telephone_reception.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Secrétariat bureautique
              </div>
            </Col>

            <Col md={6} className="mb-3">
              <Image
                src="/images/domiciliation/tax_localization.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Localisation fiscale
              </div>
            </Col>
          </Row>

          {activeCompany && (
            <div className="container mt-2 text-center">
              <h5 className="mb-3">Choisissez votre abonnement</h5>
              <div className="d-flex justify-content-center gap-4">
                <label style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="plan"
                    value="mensuel"
                    checked={selectedPlan === "mensuel"}
                    onChange={() => setSelectedPlan("mensuel")}
                    className="me-2"
                  />
                  <span className="font-bold" style={{ color: "#3392FF" }}>
                    {formatPrice(pricing.domiciliation.mensuel)} / mois
                    (abonnement mensuel)
                  </span>
                </label>

                <label style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="plan"
                    value="annuel"
                    checked={selectedPlan === "annuel"}
                    onChange={() => setSelectedPlan("annuel")}
                    className="me-2"
                  />
                  <span className="font-bold" style={{ color: "#3392FF" }}>
                    {formatPrice(pricing.domiciliation.annuel)} x 12 / an
                  </span>
                </label>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="btn mt-3"
            style={{
              backgroundColor: "#051259",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
            onClick={() => {
              if (activeCompany) {
                handleSubscribeClick();
              } else {
                navigate("/");
              }
            }}
          >
            Obtenir ce service
          </button>

          <GuideSection {...domiciliationGuide} />
        </Container>

        {/* Modal de Paiement */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Souscription</Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit} className="mt-2">
            <Modal.Body
              style={{
                maxWidth: "420px",
                margin: "0 auto",
                textAlign: "left",
              }}
            >
              <p>
                Veuillez proceder au paiement pour souscrire au service
                <strong> Domiciliation</strong>.
              </p>
              <h6 className="mt-1 mb-4">Selectionnez la méthode de paiement</h6>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <Image
                  src="/images/payment/orange.png"
                  alt="Orange Money"
                  onClick={() => handlePaymentSelect("OM")}
                  title="Orange Money CM"
                  style={{
                    width: "70px",
                    height: "70px",
                    cursor: "pointer",
                    padding: 2,
                    borderRadius: "8px",
                    border:
                      selectedPayment === "OM"
                        ? "3px solid #FF5500"
                        : "1px solid #ccc",
                  }}
                />
                <Image
                  src="/images/payment/mtn.png"
                  alt="MTN Mobile Money"
                  onClick={() => handlePaymentSelect("MOMO")}
                  title="MTN Mobile Money CM"
                  style={{
                    width: "70px",
                    height: "70px",
                    cursor: "pointer",
                    padding: 2,
                    borderRadius: "8px",
                    border:
                      selectedPayment === "MOMO"
                        ? "3px solid #FF5500"
                        : "1px solid #ccc",
                  }}
                />
                {cardMethod.available && (
                  <CardPaymentTile
                    selected={selectedPayment === CARD}
                    onSelect={() => handlePaymentSelect(CARD)}
                  />
                )}
              </div>

              {(selectedPayment === "OM" || selectedPayment === "MOMO") && (
                <>
                  <Form.Group controlId="phoneNumber" className="mb-3">
                    <PhoneInput
                      country={user.country.toLowerCase() || "cm"}
                      value=""
                      placeholder="Numéro de téléphone"
                      onChange={(phone) => {
                        const formattedPhone = phone.startsWith("+")
                          ? phone
                          : `+${phone}`;
                        formik.setFieldValue("phoneNumber", formattedPhone);
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "40px",
                        fontSize: "14px",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.phoneNumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </>
              )}
              {selectedPayment === CARD && (
                <CardPaymentNote feePercent={cardMethod.feePercent} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                variant="warning"
                style={{
                  backgroundColor: "#FF5500",
                  color: "#fff",
                  borderRadius: "10px",
                  padding: "10px 20px",
                  width: "100%",
                  marginTop: "16px",
                }}
                disabled={!formik.isValid}
              >
                Procéder au paiement
                <FaMoneyBill style={{ marginLeft: "8px" }} />
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    </Container>
  );
}

export default DomiciliationSubscription;
